import axios from 'axios';

// Centralized API URL configuration with fallback
// React environment variables are embedded at build time
// If REACT_APP_BACKEND_URL is not set, use production fallback

const getBackendUrl = () => {
  // Check if environment variable is set
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  if (envUrl && envUrl.trim() !== '') {
    return envUrl.trim();
  }
  
  // Fallback: one domain - the site itself serves /api and /uploads (secure.azamein.com is only an old alias)
  if (/(^|\.)azamein\.com$/.test(window.location.hostname)) {
    return window.location.origin;
  }
  
  // Local development fallback
  return 'http://localhost:8001';
};

export const API_URL = getBackendUrl() + '/api';
export const BACKEND_URL = getBackendUrl();

// Kosher web filters (Geder) read API answers and replace some with their HTML block page. Ask our own
// API for base64-wrapped JSON (backend app/core/encoded_json.py) and unwrap it here, for every axios call.
const isOwnApi = (url = '') => url.startsWith('/api') || url.startsWith(API_URL);
const decodeB64Json = (b64) => {
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder('utf-8').decode(bytes));
};
axios.interceptors.request.use((config) => {
  if (isOwnApi(config.url)) {
    if (config.headers && typeof config.headers.set === 'function') config.headers.set('X-Az-Enc', 'b64');
    else config.headers = { ...(config.headers || {}), 'X-Az-Enc': 'b64' };
  }
  return config;
});
const unwrap = (response) => {
  const d = response?.data;
  if (d && typeof d === 'object' && typeof d.__b64 === 'string') response.data = decodeB64Json(d.__b64);
  else if (typeof d === 'string' && /Geder|BlockPage/.test(d.slice(0, 2000)) && isOwnApi(response.config?.url)) {
    const err = new Error('This request was blocked by a web filter on this computer.');
    err.response = { ...response, status: 451, data: { detail: err.message } };
    throw err;
  }
  return response;
};
axios.interceptors.response.use(unwrap, (error) => {
  if (error?.response) unwrap(error.response);
  return Promise.reject(error);
});
